<template>
  <div id="publicClass_order">
    <div class="bottombox">
      <Header ref="header" />
    </div>
    <!-- bottombox end -->
    <div class="hotgkt_bj">
      <div class="order_Steps">
        <div class="ul">
          <div class="stepsT">
            <strong
              ><span class="left"></span><span class="right"></span
            ></strong>
          </div>
          <div class="li" :class="{ side: side1 }">订单确认</div>
          <div class="li" :class="{ side: side2 }">订单支付</div>
          <div class="li" :class="{ side: side3 }">购买成功</div>
        </div>
      </div>
      <!-- order_Steps end -->
      <div class="order_content clearfix">
        <el-form ref="ruleForm" :model="ruleForm">
          <div class="order_xx">
            <dl class="clearfix">
              <dt><img :src="CoverImg" width="100%" height="100%" /></dt>
              <dd>
                <h2 @click="clickMe()">{{ courseTitle }}</h2>
                <p><span>总课时数：</span>{{ courseClassHour }}课时</p>
                <p class="bq"><span>课程金额：</span>￥{{ coursePrice }}</p>
                <p><span>包含服务：</span></p>
                <p style="padding-top: 5px;">
                  <strong v-for="item in courseServiceType">{{ item }}</strong>
                </p>
              </dd>
            </dl>
            <div class="order_heng"></div>
            <!-- 是否有辅助课程 -->
            <div class="auxiliary clearfix" v-if="AssistCourses.length > 0">
              <h2>辅助课程</h2>
              <el-table
                ref="multipleTable"
                :data="AssistCourses"
                tooltip-effect="dark"
                style="width: 100%"
                :show-header="false"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" width="100">
                </el-table-column>
                <el-table-column label="日期" width="400">
                  <template slot-scope="scope">
                    {{ scope.row.Title }}
                  </template>
                </el-table-column>
                <el-table-column label="姓名" width="200">
                  <template slot-scope="scope">
                    {{ scope.row.ClassHour }}课时
                  </template>
                </el-table-column>
                <el-table-column width="200" label="地址" show-overflow-tooltip>
                  <template slot-scope="scope">
                    ￥{{ scope.row.Price }}元
                  </template>
                </el-table-column>
                <el-table-column label="地址" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <router-link
                      :to="{
                        path: 'course_auxiliary',
                        query: { Id: scope.row.Id }
                      }"
                      >查看详情</router-link
                    >
                  </template>
                </el-table-column>
              </el-table>
              <!-- <div style="margin-top: 20px">
                    <el-button @click="toggleSelection([tableData[1], tableData[2]])">切换第二、第三行的选中状态</el-button>
                    <el-button @click="toggleSelection()">取消选择</el-button>
                  </div> -->
            </div>
            <!-- <div class="coupons clearfix">
              <h2>优惠券</h2>
              <el-form-item class="mb0">
                <el-select v-model="ruleForm.coupons" placeholder="不使用优惠券" >
                  <el-option
                    v-for="item in couponsList"
                    :key="item.CouponTitle"
                    :label="item.CouponTitle"
                    :value="item.Amount">
                  </el-option>

                </el-select>
              </el-form-item>
            </div> -->

            <!-- <div class="order_heng"></div> -->
            <div class="coupons clearfix" v-if="couponsList.length != 0">
              <h2>优惠券</h2>
              <ul class="coupons_list">
                <li v-for="(item, index) in couponsList">
                  <div class="price_div">
                    <h3><i>￥</i>{{ item.Amount }}</h3>
                    <p class="receive" @click="usedFun(index)">
                      {{ index == onOff ? "已使用" : "立即使用" }}
                    </p>
                  </div>
                  <div class="Special_div">
                    <p>{{ item.Remark }}</p>
                    <p>{{ item.FailureTime }}截止</p>
                  </div>
                </li>
              </ul>
            </div>
            <!-- <div class="order_heng"></div> -->
            <p class="zfje">
              <strong>课程金额：￥{{ coursePrice }}，</strong>
              <strong v-if="tatol">辅助课程：￥{{ tatol }}，</strong>
              <strong v-if="couponsList.length != 0"
                >优惠金额：￥{{ coursePrice + tatol - totalPrice }}，</strong
              >
              <strong>支付金额</strong>
              <span>￥{{ totalPrice }}</span>
            </p>
          </div>
          <!-- order_xx end -->
          <div class="order_zf clearfix">
            <p class="zs">
              注：提交订单后，我们会在“我的订单-待支付”中为您保留30分钟的支付时间。
            </p>
            <div class="yd clearfix">
              <el-checkbox v-model="checked" @change="changeD"
                >我已阅读并接受<router-link
                  :to="{ path: '/agreement1_yhzx' }"
                  target="_blank"
                  >《启德考培在线用户协议》</router-link
                ></el-checkbox
              >
            </div>
            <div class="clearfix an">
              <span v-if="!checked">提交订单</span>
              <span class="tjdd" v-else @click="submitForm">提交订单</span>
              <span class="qxdd" @click="back">取消订单</span>
            </div>
          </div>
          <!-- order_zf end -->
        </el-form>
      </div>
      <!-- order_content end -->
    </div>
    <!-- hotgkt_bj end -->
  </div>
</template>

<script>
import Header from "../../components/header/Header.vue"; //公共头部
export default {
  name: "App",
  components: {
    // 将组件隐射为标签,登陆弹窗
    Header
  },
  data() {
    return {
      courseId: "",
      tokenkey: "",
      courseTitle: "",
      courseClassHour: "",
      coursePrice: "",
      fzcoursePrice: "",
      PriceList: 1, //辅助价格数组
      courseServiceType: [],
      AssistCourses: [],
      CoverImg: "",

      side1: true,
      side2: false,
      side3: false,
      ruleForm: {
        auxiliary: "",
        coupons: ""
      },
      checked: false,
      checkListId: "",
      tableData1: [],
      multipleSelection: [],
      couponsList: [], //优惠券列表
      CouponId: "", //优惠券Id
      couponUsedType: "", //优惠券 1折扣 2立减 3赠送 ,
      UsedType1: "", //折扣
      onOff: -1
    };
  },
  computed: {
    //辅助课程价格
    tatol: function() {
      let tatol = 0;
      // // console.log(tatol)
      this.multipleSelection.forEach(item => {
        tatol += item.Price;
      });
      return tatol;
    },
    // 课程总价
    totalPrice: function() {
      let tatolPrice = 0;
      if (this.couponUsedType == "") {
        tatolPrice = this.coursePrice + this.tatol;
      } else {
        switch (this.couponUsedType) {
          case 1:
            tatolPrice = this.coursePrice * this.UsedType1;
            break;
          case 2:
            tatolPrice = this.coursePrice - this.UsedType1;
            break;
          case 3:
            tatolPrice = this.coursePrice * this.UsedType1;
            break;
        }
      }
      return tatolPrice;
    }
  },
  methods: {
    //辅助课程是否点击选中
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.checkListId = "";
      //辅助课程Id
      this.multipleSelection.filter(item => {
        if (this.checkListId == "") {
          this.checkListId += item.Id;
        } else {
          this.checkListId += "," + item.Id;
        }
      });
      return this.checkListId;
    },

    usedFun(index) {
      let that = this;
      that.couponsList[index];
      that.CouponId = that.couponsList[index].CouponId; //优惠券Id
      that.couponUsedType = that.couponsList[index].Type; //优惠券 1折扣 2立减 3赠送 ,
      that.UsedType1 = that.couponsList[index].Amount;
      that.onOff = index; //控制显示立即使用或已使用
    },
    // 辅助课程价格
    // calcTatol(){
    //   let tatol = 0;
    //   // console.log(tatol)
    //   this.multipleSelection.forEach((item) => {tatol+=item.Price})
    //   return tatol
    // },
    changeD() {
      let that = this;
    },

    //提交订单
    submitForm() {
      let that = this;
      that.courseId = this.$route.query.Id;
      if (that.totalPrice === 0) {
        this.$http
          .post(
            "https://schoolapi.eiceducation.com.cn/api/CourseOrder",
            {
              CourseId: that.courseId,
              CouponId: that.CouponId,
              AssistCourseIds: that.checkListId
            },
            {
              headers: {
                "content-type": "application/json; charset=utf-8",
                token: that.tokenkey
              }
            }
          )
          .then(function(response) {
            // console.log(response)
            if (response.data.code == 200) {
              const money = response.data.results.Money;
              const Orders = response.data.results.OrderNumber;
              localStorage.setItem("Orders", Orders); //储存订单，成功页提取
              that.$http
                .get(
                  "https://schoolapi.eiceducation.com.cn/api/OrderCallBack?orderNum=" +
                    Orders +
                    "&type=1",
                  {
                    headers: {
                      "content-type": "application/json; charset=utf-8",
                      token: that.tokenkey
                    }
                  }
                )
                .then(function(result) {
                  // console.log(result.data.results.Courses);

                  localStorage.setItem("Money", 0);
                  that.$message.success("购买成功");
                  that.$router.push({ path: "/course_success" });
                })
                .catch(function(error) {
                  // console.log(error);
                });
            } else {
              return; //已购买
            }
          })
          .catch(function(error) {
            // console.log(error);
          });

        // localStorage.setItem('Money',0);
        //     that.$message.success('购买成功');
        //     that.$router.push({path: '/course_success'})
      } else {
        this.$http
          .post(
            "https://schoolapi.eiceducation.com.cn/api/CourseOrder",
            {
              CourseId: that.courseId,
              CouponId: that.CouponId,
              AssistCourseIds: that.checkListId
            },
            {
              headers: {
                "content-type": "application/json; charset=utf-8",
                token: that.tokenkey
              }
            }
          )
          .then(function(response) {
            const money = response.data.results.Money;
            const Orders = response.data.results.OrderNumber;
            const Ordertime = response.data.results.CreateTime;

            that.$router.push({
              path: "/course_pay",
              query: {
                moneytext: money,
                Orderstext: Orders
              }
            });
            that.$message.success("订单已提交");
            localStorage.setItem("kcdd", Ordertime);
            //提示已预约
            // that.$message.error(result.data.msg);
          })
          .catch(function(error) {
            // console.log(error);
          });
      }
    },
    back() {
      this.$router.go(-1);
    }
  },
  mounted: function() {
    //自动触发写入的函数
    let that = this;
    if (!this.$cookies.isKey("token")) {
      this.$router.push("/index");
    }
    that.tokenkey = that.$cookies.get("token");
    const courseId = this.$route.query.Id;
    that.$http
      .get("https://schoolapi.eiceducation.com.cn/api/Course/" + courseId)
      .then(function(response) {
        that.courseTitle = response.data.results.Title; //标题
        that.courseClassHour = response.data.results.ClassHour; //课时
        that.coursePrice = response.data.results.Price; //价格
        that.courseServiceType = response.data.results.ServiceType.split(","); //包含服务
        that.AssistCourses = response.data.results.AssistCourses; //辅助课程
        that.CoverImg = response.data.results.CoverImg; //图片
      })
      .catch(function(err) {
        // console.log(err);
        // console.log('数据错误');
      });
    //优惠券
    that.$http
      .get(
        "https://schoolapi.eiceducation.com.cn/api/Coupon?courseId=" + courseId,
        {
          headers: {
            "content-type": "application/json; charset=utf-8",
            token: that.tokenkey
          }
        }
      )
      .then(function(response) {
        // // console.log(response)
        that.couponsList = response.data.results;
      })
      .catch(function(err) {
        // console.log(err);
        // console.log('数据错误');
      });
  },
  //离开页面时清除请求接口的定时器
  beforeDestroy: function() {},
  //离开页面后
  destroyed: function() {}
};
</script>

<style scoped>
.coupons_list {
  overflow: hidden;
  margin-top: 20px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.coupons_list li {
  position: relative;
  width: 250px;
  height: 100px;
  background: url(../../assets/courselist/coupons_bg.png);
  margin: 0 10px;
}
.price_div {
  display: flex;
  justify-content: space-between;
  margin: 0 19px;
  margin-top: 18px;
  color: #fff;
}
.price_div h3 {
  font-size: 26px;
}
.price_div h3 i {
  font-size: 16px;
}
.price_div p {
  width: 82px;
  height: 28px;
  background: #ffffff;
  border-radius: 15px;
  color: #ff7e7e;
  font-size: 12px;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
}
.Special_div {
  position: absolute;
  bottom: 8px;
}
.Special_div p {
  padding-left: 19px;
  color: #fff;
  font-size: 12px;
  line-height: 16px;
}
.bottombox {
  box-shadow: 0px 3px 5px 0px rgba(233, 233, 233, 0.5);
  position: relative;
  z-index: 9;
}

.hotgkt_bj {
  background: #fafafa;
  padding-top: 20px;
  padding-bottom: 110px;
}

.mb0 {
  margin-bottom: 0;
}

.order_Steps {
  width: 1180px;
  height: 120px;
  background: #ffffff;
  border-radius: 12px;
  margin: 0 auto;
  margin-bottom: 16px;
}

.order_Steps .ul {
  width: 658px;
  height: 77px;
  padding-top: 22px;
  margin: 0 auto;
  display: -webkit-flex;
  justify-content: space-between;
  display: flex;
  position: relative;
}

.order_Steps .ul .li {
  display: inline-block;
  width: 110px;
  height: 16px;
  line-height: 16px;
  font-size: 16px;
  color: #999999;
  background: url(../../assets/publicClass/icon_JD-B.png) top no-repeat;
  text-align: center;
  padding-top: 61px;
  position: relative;
  z-index: 5;
}

.order_Steps .ul .li.side {
  background-image: url(../../assets/publicClass/icon_JD-A.png);
  color: #333333;
}

.order_Steps .ul .stepsT {
  width: 600px;
  height: 5px;
  background: #f6f6f6;
  border-radius: 3px;
  position: absolute;
  left: 29px;
  top: 65px;
  padding-top: 1px;
}

.order_Steps .ul .stepsT strong {
  display: block;
  width: 150px;
  height: 4px;
  background: #ff7e7e;
  border-radius: 3px;
}

.order_Steps .ul .stepsT strong span {
  width: 6px;
  height: 6px;
  background: #ff7e7e;
  border-radius: 3px;
  margin-top: -1px;
}

.order_Steps .ul .stepsT strong .left {
  margin-left: -1px;
}

.order_content {
  width: 1180px;
  background: #ffffff;
  border-radius: 12px;
  margin: 0 auto;
  padding-bottom: 52px;
}

.order_xx {
  width: 1080px;
  padding-top: 27px;
  margin: 0 auto;
  border-bottom: 1px #d5d5d5 solid;
}

.order_xx dl {
  min-height: 162px;
}

.order_xx dl dt {
  width: 190px;
  height: 120px;
  background: #ff9494;
  border-radius: 8px;
  float: left;
  margin-right: 16px;
}

.order_xx dl dd {
  width: 874px;
  float: left;
  text-align: left;
}

.order_xx dl dd h2 {
  font-size: 16px;
  line-height: 24px;
  color: #333;
  margin-bottom: 5px;
}

.order_xx dl dd p {
  font-size: 12px;
  line-height: 24px;
  color: #666666;
}

.order_xx dl dd p.bq {
  color: #4e5cf6;
}

.order_xx dl dd p span {
  display: inline-block;
  text-align: right;
  width: 64px;
  font-size: 12px;
  color: #666;
}

.order_xx dl dd p strong {
  display: inline-block;
  min-width: 96px;
  height: 24px;
  background: #ffbe42;
  border-radius: 12px;
  text-align: center;
  font-size: 12px;
  color: #fff;
  font-weight: 500;
  padding: 0 20px;
  box-sizing: border-box;
  margin-right: 4px;
}

.order_xx .order_heng {
  width: 1080px;
  height: 4px;
  background: #f5f6f6;
  border-radius: 4px;
}

.order_xx .auxiliary {
  padding-top: 18px;
  padding-bottom: 10px;
}

.order_xx .auxiliary h2 {
  border-bottom: 1px #d5d5d5 solid;
  font-size: 18px;
  color: #333333;
  line-height: 28px;
  padding: 2px 0;
  text-align: left;
  font-weight: 500;
  padding-bottom: 8px;
}

.order_xx .auxiliary .li {
  width: 1080px;
  text-align: left;
  padding: 24px 0;
  border-top: 1px #d5d5d5 solid;
}

.order_xx .auxiliary .li .s1 {
  display: inline-block;
  width: 344px;
  font-size: 16px;
  line-height: 16px;
  padding-left: 10px;
}

.order_xx .auxiliary .li .s2 {
  display: inline-block;
  width: 144px;
  font-size: 16px;
  line-height: 16px;
}

.order_xx .auxiliary .li strong {
  display: inline-block;
  width: 440px;
  font-size: 16px;
  line-height: 16px;
  font-weight: 500;
}

.order_xx .auxiliary .li a {
  display: inline-block;
  width: 112px;
  height: 28px;
  background: #ffffff;
  border-radius: 15px;
  border: 1px solid #d5d5d5;
  font-size: 12px;
  color: #666666;
  text-align: center;
  line-height: 28px;
}
.order_xx .auxiliary .li a:hover {
  color: #ff4256;
  border-color: #ff4256;
}

.order_xx .coupons {
  padding-top: 28px;
  padding-bottom: 30px;
  text-align: left;
}

.order_xx .coupons h2 {
  font-size: 18px;
  color: #333333;
  line-height: 28px;
  padding: 2px 0;
  text-align: left;
  font-weight: 500;
  padding-bottom: 8px;
  border-bottom: 1px #d5d5d5 solid;
  margin-bottom: 21px;
}

.order_xx .zfje {
  text-align: right;
  font-size: 16px;
  color: #333;
  line-height: 20px;
  padding-bottom: 13px;
  padding-top: 30px;
  font-weight: bold;
}

.order_xx .zfje strong {
  font-weight: 500;
  color: #999;
}

.order_xx .zfje span {
  font-size: 16px;
  color: #ff3953;
}

.order_zf {
  width: 1080px;
  margin: 0 auto;
}

.order_zf .zs {
  text-align: right;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  margin-bottom: 8px;
}

.order_zf .yd {
  text-align: right;
}

.order_zf .yd a {
  color: #4e5cf6;
}

.order_zf .an {
  float: right;
  padding-top: 20px;
}

.order_zf .an span {
  display: block;
  width: 120px;
  height: 38px;
  background: #f5f6f6;
  border-radius: 23px;
  float: right;
  margin-right: 12px;
  font-size: 16px;
  color: #999;
  line-height: 38px;
  text-align: center;
  cursor: default;
}

.order_zf .an .tjdd {
  display: block;
  width: 120px;
  height: 38px;
  background: linear-gradient(90deg, #ff7c71 0%, #ff3250 100%);
  border-radius: 23px;
  color: #fff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/page2/courseList/course_order.vue